import { createSlice } from "@reduxjs/toolkit"

export const initialEntryState = {
    entries: [],
    form: {
        date: "",
        startTime: "",
        endTime: "",
        notes: "",
        error: ""
    },
    message: "",
    loading: false
}

export const entrySlice = createSlice({
    name: 'entry',
    initialState: initialEntryState,
    reducers: {
        updateEntryForm: (state, action) => {
            state.form[action.payload.field] = action.payload.value;
        },
        setEntryFormErrors: (state, action) => {
            state.form.error = action.payload
        },
        createNewEntrySuccess: (state) => {
            state.form.date = ""
            state.form.startTime = ""
            state.form.endTime = ""
            state.form.notes = ""
            state.form.error = ""
            state.message = "Created successfully"
            state.loading = false
        },
        createNewEntryFailure: (state, action) => {
            state.form.error = action.payload
            state.loading = false
        },
        getBreakEntriesSuccess: (state, action) => {
            state.entries = action.payload;
            state.loading = false
        },
        getUpdatedEntries: (state, action) => {
            state.entries = action.payload
            state.loading = false
        },
        setEntriesLoading: (state) => {
            state.loading = true
        }
    }
})

export const {
    updateEntryForm,
    setEntryFormErrors,
    createNewEntrySuccess,
    createNewEntryFailure,
    getBreakEntriesSuccess,
    getUpdatedEntries,
    setEntriesLoading
} = entrySlice.actions;

export default entrySlice.reducer;